"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const Dataset_1 = require("../Dataset");
class CollectionDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.create = (this.sendRequest(interfaces_1.WEN_FUNC.createCollection));
        this.update = (this.sendRequest(interfaces_1.WEN_FUNC.updateCollection));
        this.updateMinted = (this.sendRequest(interfaces_1.WEN_FUNC.updateCollection));
        this.reject = (this.sendRequest(interfaces_1.WEN_FUNC.rejectCollection));
        this.mint = (this.sendRequest(interfaces_1.WEN_FUNC.mintCollection));
        this.vote = (this.sendRequest(interfaces_1.WEN_FUNC.voteController));
        this.rank = (this.sendRequest(interfaces_1.WEN_FUNC.rankController));
        this.getAllPendingLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'approved', 'rejected'],
                fieldValue: [space, false, false],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.getAllAvailableLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'approved'],
                fieldValue: [space, true],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        this.getAllRejectedLive = (space, startAfter) => {
            const params = {
                dataset: this.dataset,
                fieldName: ['space', 'rejected'],
                fieldValue: [space, true],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.CollectionDataset = CollectionDataset;
